export function roundToNearestFive(n: number): number {
  return Math.round(n / 5) * 5
}
